import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b79a42f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "accout-action animate__animated animate__flipInX animate__fast"
};
import { reactive, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getCaptchaApi, loginByAccoutApi } from "@/service/modules/login";
import { ElForm } from "element-plus";
import useLoginStore from "@/store/modules/login";
import { User } from "@element-plus/icons-vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'accout-action',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const loginStore = useLoginStore();
    const accoutForm = reactive({
      captcha: "1",
      username: "",
      password: ""
    });
    // admin 123456
    const rules = {
      username: [{
        required: true,
        message: "请输入用户名",
        trigger: "blur"
      }],
      password: [{
        required: true,
        message: "请输入密码",
        trigger: "blur"
      }],
      captcha: [{
        required: true,
        message: "请输入验证码",
        trigger: "blur"
      }]
    };
    const captchaUrl = ref("");
    const loginStatus = ref(false);
    const accoutFormRef = ref();
    getCaptchaFn();
    async function getCaptchaFn() {
      try {
        let res = await getCaptchaApi();
        captchaUrl.value = res.data;
      } catch {}
    }
    function handleLogin() {
      accoutFormRef.value?.validate(valid => {
        if (valid) loginByAccoutFn();
      });
      // loginByAccoutFn()
    }

    async function loginByAccoutFn() {
      loginStatus.value = true;
      try {
        let res = await loginByAccoutApi(accoutForm);
        loginStore.loginAction(res.data);
      } catch {
        getCaptchaFn();
      } finally {
        loginStatus.value = false;
      }
    }
    onMounted(() => {
      let query = route.query;
      // console.log('query', query)
      loginStore.redirect = query.redirect;
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElForm), {
        ref_key: "accoutFormRef",
        ref: accoutFormRef,
        model: accoutForm,
        rules: rules
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          prop: "username"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "请输入账号",
            modelValue: accoutForm.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => accoutForm.username = $event),
            class: "input_3",
            size: "large"
          }, {
            prefix: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "el-input__icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(User))]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "password"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "请输入密码",
            modelValue: accoutForm.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => accoutForm.password = $event),
            size: "large",
            type: "password",
            class: "input_3",
            "show-password": ""
          }, {
            prefix: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "el-input__icon"
            }, {
              default: _withCtx(() => [_createVNode(_unref(User))]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          style: {}
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            loading: loginStatus.value,
            size: "large",
            type: "primary",
            class: "w100",
            onClick: handleLogin
          }, {
            default: _withCtx(() => [_createTextVNode("登 录")]),
            _: 1
          }, 8, ["loading"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});